<div (click)="$entry().fct()" [ngClass]="$entry().type === 'test' ? 'cm-test-button' : 'cm-info-button'" [matTooltip]="$entry().tooltip">
    @if ($entry().type === "test") {
        <i class="far fa-vial-virus"></i>
    } @else {
        <i class="far fa-info-circle"></i>
    }
    {{ $entry().name }}
</div>
